<template>
    <div class="mt-5">
        <spiel-bericht-print-header-team :spiel="spiel" :type="type">
        </spiel-bericht-print-header-team>
        <table class="text-center mt-3">
            <tr class="grey lighten-3">
                <td class="tableLabel" colspan="2">Pass Nr.</td>
                <td class="font-weight-bold body-2" style="width: 80%;">Spieler/in</td>
                <td class="tableLabel px-1">Bahn</td>
            </tr>
            <tr v-for="i in nrOfSpieler" :key="spiel.partien[i][type].spieler.id"
                class="spieler body-2">
                <td class="tableContent px-1" colspan="2"
                    style="min-width: 84px; height: 33px">
                    {{spiel.partien[i][type].spieler.name.substr(0,6)}}</td>
                <td class="pl-1 text-left text-truncate" style="max-width: 200px">
                    {{spiel.partien[i][type].spieler.name.substr(9)}}
                    <div class="caption grey--text text--darken-1 d-inline-block mr-2"
                         style="float: right">
                        <span>{{spiel.getAltersklasse(spiel.partien[i][type].spieler)}}</span>
                    </div>
                </td>
                <td>{{spiel.partien[i][type].bahn}}</td>
            </tr>
            <tr class="font-weight-bold grey lighten-3">
                <td colspan="4" class="pSmall">Ersatzspieler/in</td>
            </tr>
            <tr v-for="j in nrOfErsatzSpieler" :key="j"
                class="body-2" style="height: 36px;">
                <td class="px-1" style="width: 26px">E{{j}}</td>
                <td class="tableContent px-1">{{spiel[type].ersatzSpieler[j].name.substr(0,6)}}</td>
                <td class="pl-1 text-left text-truncate" style="max-width: 200px" colspan="2">
                    {{spiel[type].ersatzSpieler[j].name.substr(9)}}
                    <div class="caption grey--text text--darken-1 d-inline-block mr-2"
                         style="float: right">
                        <span>{{spiel.getAltersklasse(spiel[type].ersatzSpieler[j])}}</span>
                    </div>
                </td>
            </tr>
        </table>
        <spiel-bericht-print-sign class="mt-3">
            Sportkapitän/in {{typeText}}: <span class="font-weight-bold">{{team.captain}}</span>
        </spiel-bericht-print-sign>
    </div>
</template>

<script>
    import SpielBerichtPrintSign from "./spielBerichtPrint_Sign";
    import SpielBerichtPrintHeaderTeam from "./spielBerichtPrint_HeaderTeam";

    export default {
        components: {
            SpielBerichtPrintHeaderTeam,
            SpielBerichtPrintSign},
        name: "spiel-bericht-print-ma-l-team",
        props: ['spiel', 'type'],
        computed: {
            team(){
                return this.spiel[this.type];
            },
            nrOfSpieler(){
                return Object.keys(this.spiel.partien).length;
            },
            nrOfErsatzSpieler(){
                return Object.keys(this.spiel[this.type].ersatzSpieler).length;
            },
            typeText() { return this.type==='heim' ? 'Heim' : 'Gast'}
        },
    }
</script>

<style scoped>
    table { width: 100%; border-spacing: 0; border-top: solid 1px black; border-left: solid 1px black }/*border-collapse: collapse;*/
    td { border-bottom: solid 1px black; border-right: solid 1px black }
    .tableLabel {font-size: 11px}
    .tableContent {padding: 6px 0}
    .pSmall {padding: 2px 0; font-size: 11px}
</style>